import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

import { CreateVehicleInsuranceClaimDto } from './create-vehicle-insurance-claim.dto';

/**
 * Update vehicle insurance claim	DTO
 */
export class UpdateVehicleInsuranceClaimDto extends CreateVehicleInsuranceClaimDto {
	@TransformInt()
	id!: number;
}
